
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.75 3.028a.75.75 0 00-.75.75V6.86c0 .414.336.75.75.75h14.388a.75.75 0 00.75-.75V3.778a.75.75 0 00-.75-.75H2.75zm0 6.68a.75.75 0 00-.75.75v3.084c0 .414.336.75.75.75H12a.75.75 0 00.75-.75v-3.083a.75.75 0 00-.75-.75H2.75zm0 6.68a.75.75 0 00-.75.75v3.084c0 .414.336.75.75.75h18.5a.75.75 0 00.75-.75v-3.083a.75.75 0 00-.75-.75H2.75z"}})])
          )
        }
      }
    